import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@nerdwallet/currency';

import classNames from 'classnames';
import { repeatable, boolCheckboxSpec } from '../../lib/editing-configs';

import ImageContentRow from './image-content-row';
import ImageContentBox from './image-content-box';

import './image-content.less';

const ImageContent = ({ boxes, columns, centerText }) => {
  const boxSections = boxes.map((box) => (
    <ImageContentBox
      {...box}
      key={`${box.captionHeader}`}
      centerText={centerText}
    />
  ));

  return (
    <Box className={classNames(['image-content__cont'])}>
      <ImageContentRow centeredInParent standardMaxWidths columns={columns}>
        {boxSections}
      </ImageContentRow>
    </Box>
  );
};

ImageContent.propTypes = {
  columns: ImageContentRow.propTypes.columns,
  boxes: PropTypes.arrayOf(PropTypes.shape(ImageContentBox.propTypes)),
  centerText: PropTypes.bool,
};

ImageContent.getEditingConfig = (componentDocument) => [
  ...ImageContentRow.getEditingConfig(),
  boolCheckboxSpec('centerText', 'Center align title and body?'),
  repeatable('boxes', 'Content block', 'Content block', (index) =>
    ImageContentBox.getEditingConfig(componentDocument.props.boxes[index])
  ),
];

ImageContent.defaultProps = {
  boxes: [],
  columns: '1',
  centerText: false,
};

ImageContent.displayName = 'ImageContent';

export default ImageContent;
